import { useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import GlobalContext from '../contexts/GlobalContext';
import GlobalContextI from '../interfaces/GlobalContext';
import dropToken from '../functions/dropToken';

// 6 hours of inactivity before auto-logout. User requirement is "stay
// logged in at least 4 hours"; 6h gives buffer.
const IDLE_MS = 6 * 60 * 60 * 1000;

const IdleLogout = () => {
    const { user, setUser } = useContext<GlobalContextI>(GlobalContext);
    const history = useHistory();
    const timer = useRef<number | null>(null);

    useEffect(() => {
        if (!user) return;

        const reset = () => {
            if (timer.current) window.clearTimeout(timer.current);
            timer.current = window.setTimeout(() => {
                dropToken(setUser!, history).catch(() => {});
            }, IDLE_MS);
        };

        const events: (keyof WindowEventMap)[] = [
            'mousemove',
            'mousedown',
            'keydown',
            'touchstart',
            'scroll',
        ];
        events.forEach((e) =>
            window.addEventListener(e, reset, { passive: true })
        );
        reset();

        return () => {
            events.forEach((e) => window.removeEventListener(e, reset));
            if (timer.current) window.clearTimeout(timer.current);
        };
    }, [user, setUser, history]);

    return null;
};

export default IdleLogout;
